import Vue from 'vue';

import { SiteContext } from '@/Domain/SiteContext';

console.debug("Initializing frontend-1.1 subsystem...");

if (process.env.NODE_ENV !== "production") {
    Vue.config.devtools = true;
}

import {store} from "@/UI/stores";

Vue.prototype.$siteContext = new SiteContext();

require('./extensions');
require('./axios-setup');
require('./UI');

try {
    (window as any).app = new Vue({
        el: '#new-app',
        store: store
    });
}
catch (e) {
    console.warn(e);
}

import './extensions';
import './ad-hoc';
